import Stack from '@mui/material/Stack'
import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { SxProps } from '@mui/material/styles'

export interface AuthMessageProps {
   message: string
   sx?: SxProps
}

export default observer(function AuthMessage({ message, sx }: AuthMessageProps) {

   return <Box sx={{
      ...(sx || {}),
      padding: 2,
      backgroundColor: 'info.50',
      borderRadius: '8px',
   }}>
      <Stack spacing={1} direction='row'>
         <InfoOutlinedIcon sx={{ color: 'info.800' }} fontSize='small' />
         <Typography variant='body2' sx={{ color: 'info.800', textAlign: 'left', mr: 1 }}>
            {message}
         </Typography>
      </Stack>
   </Box>
})
